import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import AddInsightForm from "./addInsightForm"
import ConfirmNewInsight from "./confirmMarketInsight"

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

enum AddMarketInsight {
  Form,
  Confirm,
  Error,
}

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const AddNewInsightModal = ({
  onClose,
  parent2Callback,
}: {
  onClose: () => void
  parent2Callback: () => void
}) => {
  const [step, setStep] = useState<AddMarketInsight>(AddMarketInsight.Form)
  const [data, setData] = useState<{
    title: string
    subtitle: string
    description: string
    error: string
  }>({
    title: "",
    subtitle: "",
    description: "",
    error: "",
  })

  return (
    <Overlay onClick={() => setStep(AddMarketInsight.Form)}>
      <ModalCard onClose={onClose}>
        {step === AddMarketInsight.Form && (
          <AddInsightForm
            onSubmit={(title, subtitle, description) => {
              setData((prev) => ({ ...prev, title, subtitle, description }))
              setStep(AddMarketInsight.Confirm)
            }}
          />
        )}
        {step === AddMarketInsight.Confirm && (
          <ConfirmNewInsight
            title={data.title}
            subtitle={data.subtitle}
            description={data.description}
            onCancel={() => setStep(AddMarketInsight.Form)}
            onError={(error) => {
              setData((prev) => ({ ...prev, error }))
              setStep(AddMarketInsight.Error)
            }}
            onSuccess={() => onClose()}
            parentCallback={() => parent2Callback()}
          />
        )}
        {step === AddMarketInsight.Error && `API Error: ${data.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default AddNewInsightModal
